import { formatValues } from './formatValues';

export const testCard = (card, cards) => !!formatValues({ card }, cards).type;
